// extracted by mini-css-extract-plugin
module.exports = {"var-sp-down-2":"0.5rem","varSpDown2":"0.5rem","addressCollectionHeader":"addressCollectionHeader--1a0e3"};